// Whimsical loading verbs, inspired by Claude Code's spinner list,
// curated for the CAD / parametric modeling context.
export const SPINNER_VERBS = [
  'Architecting',
  'Bootstrapping',
  'Brewing',
  'Calculating',
  'Cerebrating',
  'Channeling',
  'Chiseling',
  'Cogitating',
  'Composing',
  'Computing',
  'Concocting',
  'Conjuring',
  'Considering',
  'Contemplating',
  'Crafting',
  'Creating',
  'Crunching',
  'Crystallizing',
  'Cultivating',
  'Deliberating',
  'Envisioning',
  'Extruding',
  'Fabricating',
  'Fiddle-faddling',
  'Finagling',
  'Forging',
  'Forming',
  'Generating',
  'Hatching',
  'Ideating',
  'Imagining',
  'Incubating',
  'Kneading',
  'Lofting',
  'Manifesting',
  'Marinating',
  'Materializing',
  'Meandering',
  'Mulling',
  'Musing',
  'Noodling',
  'Orchestrating',
  'Percolating',
  'Philosophizing',
  'Pondering',
  'Pontificating',
  'Prestidigitating',
  'Reticulating',
  'Ruminating',
  'Sculpting',
  'Simmering',
  'Sketching',
  'Spinning',
  'Sprouting',
  'Stewing',
  'Summoning',
  'Synthesizing',
  'Tessellating',
  'Thinking',
  'Tinkering',
  'Transfiguring',
  'Wrangling',
];

export function pickSpinnerVerb(): string {
  return SPINNER_VERBS[Math.floor(Math.random() * SPINNER_VERBS.length)];
}
